import React, { useState } from "react";
import { Link } from "gatsby";
import "./modernArticleCard.scss";

const READ_LABELS = {
  article: "Read Article",
  "white-paper": "Read White Paper",
  "client-story": "Read Case Study",
  podcast: "Listen to Podcast",
};

function ModernArticleCard({ article, index = 0, featured = false }) {
  const [imageLoaded, setImageLoaded] = useState(false);

  const articleLink = `/${article.slug_type}/${article.slug}/`;
  const readLabel = READ_LABELS[article.slug_type] || "Read More";

  if (featured) {
    return (
      <Link
        to={articleLink}
        className="modern-article-card modern-article-card--featured"
        target="_blank"
      >
        <div className="card-image-wrapper">
          <div
            className={`card-image-skeleton ${imageLoaded ? "hidden" : ""}`}
          />
          <img
            src={article?.og_image}
            alt={article?.imageAltTxt || article?.title}
            className={`card-image ${imageLoaded ? "loaded" : ""}`}
            onLoad={() => setImageLoaded(true)}
          />
          <div className="card-image-overlay" />
          <div className="card-featured-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
            Featured
          </div>
        </div>

        <div className="card-content">
          {article.article_tag && (
            <span className="card-tag">{article.article_tag}</span>
          )}
          <h2 className="card-title">{article?.title}</h2>
          <p className="card-description">{article?.og_description}</p>

          <div className="card-footer">
            <div className="card-read-more">
              {readLabel}
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={articleLink}
      className="modern-article-card"
      target="_blank"
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      <div className="card-image-wrapper">
        <div className={`card-image-skeleton ${imageLoaded ? "hidden" : ""}`} />
        <img
          src={article?.og_image}
          alt={article?.imageAltTxt || article?.title}
          className={`card-image ${imageLoaded ? "loaded" : ""}`}
          onLoad={() => setImageLoaded(true)}
        />
        <div className="card-image-overlay" />
      </div>

      <div className="card-content">
        {article.article_tag && (
          <span className="card-tag">{article.article_tag}</span>
        )}
        <h3 className="card-title">{article?.title}</h3>
        <p className="card-description">{article?.og_description}</p>

        <div className="card-footer">
          <div className="card-read-more">
            {readLabel}
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default ModernArticleCard;
